import React from 'react';
import { withRouter } from 'react-router-dom';
import { StringUtil } from 'utils/StringUtil';
import { RouteNames } from 'router';
import VideoInfoModule from 'components/templates/videoInfoModule';
// eslint-disable-next-line
import styles from "./styles.scss";

const CraftBeer = props => {
  const {
    craftBeerSectionData: {
      thumbnail,
      heading,
      sub_heading,
      paragraph,
      image,
      path,
      video,
      video_thumbnail_url,
    },
    beerData,
    showLineUpButton = false,
  } = props.data;

  const videoData = {
    __html: video,
  };

  let thumbNailUrl = `${path}${thumbnail}/${image}`;
  const content = StringUtil.sliceHtml(paragraph);

  const handleClick = () => {
    let element = document.getElementById('beer-explorer');
    element.scrollIntoView();
  };

  const noPadding = props.location.pathname === RouteNames.restaurants;

  return (
    <div
      className={
        beerData && beerData.length > 0
          ? 'craft-beer-section no-padding'
          : 'craft-beer-section'
      }
    >
      <VideoInfoModule
        thumbNailUrl={thumbNailUrl}
        heading={heading}
        subHeading={sub_heading}
        content={content}
        videoData={videoData}
        videoThumbnailUrl={video_thumbnail_url}
        containerClassName={noPadding && 'beer-brewery'}
        buttonName={
          showLineUpButton && beerData && beerData.length > 0
            ? 'VIEW OUR LINEUP'
            : null
        }
        onClick={handleClick}
      />
    </div>
  );
};

export default withRouter(CraftBeer);
